import React from 'react';
import { calculateLeadScore } from '../../utils/scoring';
import { Lead } from '../../types/lead';
import { CheckCircle2 } from 'lucide-react';
interface ScoreBreakdownProps {
  lead: Lead;
}
export function ScoreBreakdown({
  lead
}: ScoreBreakdownProps) {
  const {
    score,
    breakdown
  } = calculateLeadScore(lead);
  return <div className="card p-5" data-id="element-517">
      <div className="flex items-center justify-between mb-4" data-id="element-518">
        <h3 className="text-[14px] font-semibold text-growthly-text" data-id="element-519">
          Desglose de Score
        </h3>
        <div className="text-[24px] font-bold text-growthly-text" data-id="element-520">{score}</div>
      </div>

      <div className="space-y-2" data-id="element-521">
        {breakdown.map((item, idx) => <div key={idx} className={`flex items-center justify-between text-[13px] p-2 rounded ${item.applied ? 'bg-white/5' : ''}`} data-id="element-522">
            <div className="flex items-center" data-id="element-523">
              {item.applied ? <CheckCircle2 className="w-4 h-4 text-growthly-text mr-2" data-id="element-524" /> : <div className="w-4 h-4 border border-white/10 rounded-full mr-2" data-id="element-525"></div>}
              <span className={item.applied ? 'text-growthly-text font-medium' : 'text-growthly-muted'} data-id="element-526">
                {item.rule}
              </span>
            </div>
            <span className={item.applied ? 'text-growthly-text font-bold' : 'text-growthly-muted'} data-id="element-527">
              +{item.points}
            </span>
          </div>)}
      </div>
    </div>;
}